import Swiper from 'swiper/dist/js/swiper.js';

function init() {
  const quoteSwiper = document.querySelector('.quote__swiper');
  const quoteSwiperSelector = '.swiper-container.quote__swiper';

  if (quoteSwiper) {
    const loaderSelector = '.quote__loaderinner';
    const loaderAnimationClassName = 'quote__loaderinner--animated';
    const swiper = new Swiper (quoteSwiperSelector, {
      direction: 'horizontal',
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      pagination: {
          el: '.quote__pagination',
          type: 'bullets',
          clickable: true
        },
      on: {
        slideChangeTransitionEnd: function () {
          Array.from(this.slides).map((slide) => {
            let loader = slide.querySelector(loaderSelector);
            loader.classList.remove(loaderAnimationClassName);
          });
          this.slides[this.activeIndex].querySelector(loaderSelector).classList.add(loaderAnimationClassName);
        },
      },
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Quotes.js